import { useSelector } from "react-redux";

const useDesings = () => {
  const { data } = useSelector(state => state.desings);
  const processDesings = useSelector(state => state.processDesings);

  const getArticlesWithDesings = () => {
    return processDesings.data.map(item => item.articleId).filter((value, index, self) => self.indexOf(value) === index);
  };

  return { desings: data, getArticlesWithDesings: getArticlesWithDesings };
};

export default useDesings;
